export default {
    path: 'integrations',
    component: () => import(/* webpackChunkName: "token-module" */ './index.vue'),
    name: 'token',
};
